/**
 * Markdown-it block plugin for ::: aside containers
 * @fileoverview Matches the markdown-editor aside syntax:
 *
 *   ::: TYPE            (fence line, optional type token, e.g. `:::note`)
 *   …full markdown…
 *   :::                 (bare close fence, at least as many colons)
 *
 * Output: <div class="cm-aside-widget"><aside class="cm-aside-type-TYPE">…</aside></div>
 * An unterminated aside is NOT an aside — it renders as a regular paragraph,
 * exactly like the editor's static renderer.
 */

const getLine = (state, n) =>
  state.src.slice(state.bMarks[n] + state.tShift[n], state.eMarks[n]);

function asideBlockRule(state, startLine, endLine, silent) {
  const openMatch = /^\s*:::+\s*(\S*)\s*$/.exec(getLine(state, startLine));
  if (!openMatch) return false;
  const fenceLen = openMatch[0].trim().match(/^:+/)[0].length;

  let closeLine = -1;
  for (let n = startLine + 1; n < endLine; n++) {
    const m = /^\s*(:+)\s*$/.exec(getLine(state, n));
    if (m && m[1].length >= fenceLen) {
      closeLine = n;
      break;
    }
  }
  if (closeLine === -1) return false; // unterminated → render raw

  if (silent) return true;

  const openToken = state.push('aside_open', 'aside', 1);
  openToken.markup = ':::';
  openToken.block = true;
  openToken.map = [startLine, closeLine];
  const type = openMatch[1] ? openMatch[1].toLowerCase() : '';
  if (type) {
    openToken.attrJoin('class', `cm-aside-type-${type}`);
  }

  // CONTENT is full markdown — tokenize recursively with the same instance.
  state.md.block.tokenize(state, startLine + 1, closeLine);

  const closeToken = state.push('aside_close', 'aside', -1);
  closeToken.markup = ':::';
  closeToken.block = true;

  state.line = closeLine + 1;
  return true;
}

export default function asidePlugin(md) {
  md.block.ruler.before('fence', 'aside_block', asideBlockRule, { alt: [] });

  md.renderer.rules.aside_open = (tokens, idx, options, env, slf) =>
    `<div class="cm-aside-widget"><aside${slf.renderAttrs(tokens[idx])}>\n`;
  md.renderer.rules.aside_close = () => `</aside></div>\n`;
}
